import { type Parser } from "../../base_classes/dto_parser.d";

const parsers: Parser[] = [
  {
    field: "margin.direct.percentage",
    parser: "float",
  },
  {
    field: "margins.premium.percentage",
    parser: "float",
  },
  {
    field: "margins.standard.percentage",
    parser: "float",
  },
  {
    field: "margin.direct.amount",
    parser: "float",
  },
  {
    field: "margins.premium.amount",
    parser: "float",
  },
  {
    field: "margins.standard.amount",
    parser: "float",
  },
];

export default parsers;
